import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { SpSwitchComponent } from '@ui/sp-switch';
import { SpRadioGroupComponent } from '@ui/sp-radio-group';

import { SpFormControlsModule } from '@components/sp-form-controls';
import { SpColorPickerModule } from '@components/sp-color-picker/src/sp-color-picker.module';

import { SpFormInputSettingsComponent } from './sp-form-input-settings.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        BsDropdownModule,
        TooltipModule,
        SpSwitchComponent,
        SpRadioGroupComponent,
        SpFormControlsModule,
        SpColorPickerModule,
        SpFormInputSettingsComponent,
    ],
    exports: [SpFormInputSettingsComponent],
})
export class SpFormInputSettingsModule {}
